// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__20Dsg","inputWrap":"styles_inputWrap__LTbdi","input":"styles_input__1OEx2"};